import React, { Component } from 'react';

import people from '../../svg/people.svg';

class ErrorMessage extends Component {
    /**
     * this class have the code of the error popup message 
     * and it displayes the generic error code for everything
     */

    render() {

        return (
            <div className="popup-back">
                <div className="popup-body-container">
                    <div className="">
                        <img className="popup-img" src={people} alt="" />
                    </div>
                    <div className="popup-title">
                        Something went wrong
                    </div>
                    <div className="popup-description">
                        Please, Try Again after sometime.
                    </div>
                    <input type="button" className="popup-btn" value="Dismiss" onClick={this.props.onCloseClick.bind(this)} />
                </div>
            </div>
        )
    }
}

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/CommonComponents/ErrorMessage.js